import React from 'react';
import {View, Text} from 'react-native';
import QRCode from 'react-native-qrcode-svg';
import {createStyles} from '../../utils/createStyles';
import {Dialog} from '@rneui/themed';
type Props = {
  value: string;
  logoImg: any;
  visible: boolean;
  onClose: () => void;
};
const styles = createStyles({
  qrcodeText: {
    marginTop: '2rem',
    fontSize: '2rem',
    color: '#fff',
  },
  qrcode: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
const QRCodeModal: React.FC<Props> = ({value, logoImg, visible, onClose}) => (
  <Dialog isVisible={visible} onBackdropPress={onClose}>
    <Dialog.Title title="微信扫码下载" />
    {value === '' ? (
      <Dialog.Loading />
    ) : (
      <View style={styles.qrcode}>
        <QRCode
          value={value}
          logo={logoImg}
          logoBorderRadius={1}
          color="#191919"
          backgroundColor="#ffffff"
          logoSize={30}
          size={300}
        />
        <Text style={styles.qrcodeText}>扫码下载</Text>
      </View>
    )}

    <Dialog.Actions>
      <Dialog.Button title="关闭" onPress={onClose} />
    </Dialog.Actions>
  </Dialog>
);

export default QRCodeModal;
